import etReferenceDataConfig from '@/api/config/etReferenceDataConfig'
import { queryKeys } from '@/constant/common'
import { CreateHistorical } from '@/types/historical'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreateHistorical): Promise<void> {
  await etReferenceDataConfig.create(payload)
}

function useAddReference() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateHistorical) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.etReference])
      toast.success(t('addEtReferenceSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('addEtReferenceError'))
    },
  })
}

export default useAddReference
